import api from "services/api";

export const saveContractPayment = async (payment, paymentId) => {
  const response = paymentId != null
    ? await api.put(`/ContractPayment/${paymentId}`, {
      paymentQuantity: payment.paymentQuantity, paymentAmount: payment.paymentAmount, notes: payment.notes,
    })
    : await api.post("/ContractPayment", payment);
  return response.data;
};

export const deleteContractPayment = async (paymentId) => {
  await api.delete(`/ContractPayment/${paymentId}`);
};
